const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 9.979V16h-6v6H2V3a1 1 0 0 1 1-1h13.148L17.359.646A4.934 4.934 0 0 1 18.07 0H3a3 3 0 0 0-3 3v21h18.414L24 18.414V7.979Zm-4 11.607V18h3.586Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.729 11.82 7.611-8.507a.945.945 0 0 1 1.372-.038.943.943 0 0 1 0 1.335l-8.032 8.033a4.964 4.964 0 0 1 1.042 1.785l8.4-8.4a2.947 2.947 0 0 0 0-4.163 2.943 2.943 0 0 0-4.276.118l-8.136 9.093a4.967 4.967 0 0 1 2.019.744ZM10 13c-4 0-5 6-5 6h5a3 3 0 0 0 0-6Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAlt);
export default __webpack_public_path__ + "static/media/edit-alt.7a2979f94fed15825e0800dad96a3073.svg";
export { ForwardRef as ReactComponent };